export function point(lat: number, lng: number) {
  var geometry = {
    type: "Point" as "Point",
    coordinates: [lat, lng],
  };
  return geometry;
}
